const i18n = {
    CHANGE_DEFAULT_LANGUAGE: 'CHANGE_DEFAULT_LANGUAGE',
    LOAD_DEFAULT_LANGUAGE: 'LOAD_DEFAULT_LANGUAGE'
}

export default i18n;
